import { TITLE_AUTO_GENERATOR_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import {
  CreateTitleAutoGeneratorRequest,
  TitleAutoGenerator,
  UpdateTitleAutoGeneratorRequest,
} from '../type/titleAutoGeneratorType';

class TitleAutoGeneratorService extends ApiService<TitleAutoGenerator> {
  constructor() {
    super(TITLE_AUTO_GENERATOR_API_PATH);
  }

  // Override create method
  public async create(data: CreateTitleAutoGeneratorRequest): Promise<TitleAutoGenerator> {
    return super.create(data as any);
  }

  // Override update method
  public async update(
    id: number,
    data: UpdateTitleAutoGeneratorRequest
  ): Promise<TitleAutoGenerator> {
    return super.update(id, data as any);
  }
}

export const titleAutoGeneratorService = new TitleAutoGeneratorService();
